// extracted by mini-css-extract-plugin
export default {"timer":"Timer_timer__zy9xZ","time_wrapper":"Timer_time_wrapper__dJR47","time":"Timer_time__Ar9kT","circle":"Timer_circle__PhPw-","smaller_text":"Timer_smaller_text__yQ2cI"};